import { environmentDev } from "./environment.dev.az";
import { IEnvironment } from "./environment.model";

// configuration used for the preview environments

export const environment: IEnvironment = {
    ...environmentDev,
    PCXBusiness: "https://pcx.seliselocal.com/api/business-pcx/PCXWebService/" // this is the default url
    // PCXBusiness: "https://msblocks.seliselocal.com/api/ipexaudit-1252/PCXWebService/"
};

export const environmentPreview = environment;